<template>
  <div style="display: inline-block">
    <slot :filter="filterVal" :total="total">
      <el-button :disabled="disabled" :type="btnType" :plain="btnPlain" :size="btnSize" @click="isOpen = true">
        {{ btnText }}
        <span v-if="total">{{ total }}</span>
      </el-button>
    </slot>
    <dialog-condition v-model="openDialog" :filter.sync="filterVal" @save="$emit('save', $event)" />
  </div>
</template>

<script>
import DialogCondition from './DialogCondition'

export default {
  name: 'DialogConditionBtn',
  components: {
    DialogCondition
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filter: {
      type: [Object, null],
      default: null
    },
    btnText: {
      type: String,
      default: '更多筛选条件'
    },
    btnType: {
      type: String,
      default: 'primary'
    },
    btnSize: {
      type: String,
      default: 'small'
    },
    btnPlain: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    event: 'visibility',
    prop: 'visible'
  },
  data() {
    return {
      isOpen: false,
      total: 0
    }
  },
  computed: {
    openDialog: {
      get() {
        return this.$scopedSlots.default ? this.visible : this.isOpen
      },
      set(bool) {
        if (this.$scopedSlots.default) {
          this.$emit('visibility', bool)
        } else {
          this.isOpen = bool
        }
      }
    },
    filterVal: {
      get() {
        return this.filter
      },
      set(val) {
        this.$emit('update:filter', val)
      }
    }
  },
  watch: {
    filterVal: {
      handler(val) {
        this.total = this.getTotal(val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getTotal(filter) {
      let ruleSize = filter?.rules?.length ?? 0
      for (const rg of filter?.ruleGroups || []) {
        const size = this.getTotal(rg)
        ruleSize += size
      }
      return ruleSize
    }
  }
}
</script>
